import React from 'react';
import ContentBlock from "./ContentBlock";
import * as S from "../styles";

// Импорт SVG как React компонентов
import {ReactComponent as BlocksImg1} from '../images/block-1.svg?react';
import {ReactComponent as BlocksImg21} from '../images/block-2-1.svg?react';
import {ReactComponent as BlocksImg22} from '../images/block-2-2.svg?react';
import {ReactComponent as BlocksImg31} from '../images/block-3-1.svg?react';
import {ReactComponent as BlocksImg32} from '../images/block-3-2.svg?react';

const ContentBlocksSection = ({ i18n }) => {
    const blocks = [
        {
            type: 'odd',
            blockNum: 1,
            images: [
                { Component: BlocksImg1, width: '432px', height: '284px' }
            ],
            className: 'block-pic-1'
        },
        {
            type: 'even',
            blockNum: 2,
            images: [
                { Component: BlocksImg21, width: '160px', height: '136px' },
                { Component: BlocksImg22, width: '160px', height: '136px' }
            ],
            className: 'block-pic-2'
        },
        {
            type: 'odd',
            blockNum: 3,
            images: [
                { Component: BlocksImg31, width: '176px', height: '255px' },
                { Component: BlocksImg32, width: '176px', height: '255px' }
            ],
            className: 'block-pic-3'
        }
    ];

    return (
        <S.AnimatedBlocks>
            {blocks.map((block, index) => (
                <ContentBlock
                    key={block.blockNum}
                    {...block}
                    i18n={i18n}
                    index={index}
                />
            ))}
        </S.AnimatedBlocks>
    );
};

export default ContentBlocksSection;